import { Auth0Provider, useAuth0 } from "@auth0/auth0-react"
import "@fontsource/roboto/300.css"
import "@fontsource/roboto/400.css"
import "@fontsource/roboto/500.css"
import "@fontsource/roboto/700.css"
import { ThemeProvider } from "@mui/material"
import { LocalizationProvider } from "@mui/x-date-pickers"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { Provider } from "react-redux"
import { AppRoutes } from "./AppRoutes"
import { store } from "./app/apis"
import "./i18n/i18n"
import { lightTheme } from "./theme"
import { setAuth0 } from "./utils/auth0Utils"

const AppWrapper = () => {
  const auth0 = useAuth0()
  setAuth0(auth0)
  return (
    <>
      <ThemeProvider theme={lightTheme}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <AppRoutes />
        </LocalizationProvider>
      </ThemeProvider>
    </>
  )
}

const root = createRoot(document.getElementById("root")!)
root.render(
  <StrictMode>
    <Auth0Provider
      domain={import.meta.env.VITE_AUTH0_DOMAIN}
      clientId={import.meta.env.VITE_AUTH0_CLIENT_ID}
      authorizationParams={{
        // scope: "openid profile email",
        audience: "mbls-global-api",
        redirect_uri: window.location.origin,
      }}
      cacheLocation="localstorage"
    >
      <Provider store={store}>
        <AppWrapper />
      </Provider>
    </Auth0Provider>
  </StrictMode>,
)
